<template>
  <div class="home">
    <section class="header">
      <v-row>
        <v-col cols="12" sm="6" class="header-content">
          <!-- <v-row>
            <v-col cols="6" sm="6">
              <h1 class="logo">{{ $t("jawab") }}</h1>
            </v-col>
            <v-col cols="6" sm="6">
           
            </v-col>
          </v-row> -->

          <div class="first-half">
            <div class="content">
              <h2 class="title">{{ $t("mainTitle") }}</h2>
              <p class="desc">
                لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل
                ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم مطبوعه ...
              </p>
              <div class="btns">
                <v-btn
                  class="primary-btn"
                  large
                  router
                  to="/teachersignup"
                  v-if="!isLoggedIn"
                  >{{ $t("IAMTeacher") }}</v-btn
                >
                <v-btn
                  class="second-btn"
                  large
                  router
                  to="/studentsignup"
                  v-if="!isLoggedIn"
                  >{{ $t("IAMStudent") }}</v-btn
                >
              </div>
            </div>
          </div>
        </v-col>
        <!-- 
        <v-col cols="12" sm="6" class="second-half text-left">
          <v-btn class="third-btn" large>تسجيل الدخول</v-btn>
        </v-col>-->
      </v-row>
    </section>

    <section class="features">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4">
            <div class="item text-center">
              <v-icon large class="icon">video_call</v-icon>
              <p class="title">{{ $t("feature1") }}</p>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div class="item text-center">
              <v-icon class="icon">calendar_today</v-icon>
              <p class="title">{{ $t("feature2") }}</p>
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <div class="item text-center">
              <v-icon large class="icon">access_time</v-icon>
              <p class="title">{{ $t("feature3") }}</p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="teachers" v-if="teachers.length > 0">
      <v-container>
        <h2 class="section-title">{{ $t("teachers") }}</h2>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="3"
            class="teacher"
            v-for="(teacher, index) in teachers"
            :key="index"
          >
            <v-card
              class="mx-auto"
              max-width="300"
              outlined
              elevation="1"
              :to="'/teachers/' + teacher.id"
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    :src="teacher.img"
                    class="teacher-image"
                    alt
                    v-if="teacher.img"
                  />
                  <img
                    src="../assets/images/women.png"
                    class="teacher-image"
                    alt
                    v-else
                  />
                  <p class="text-center teacher-name">
                    {{ teacher.name }}
                  </p>
                  <div
                    class="rate"
                    style="text-align:center"
                    v-if="teacher.rating_count >= 3"
                  >
                    <v-icon :color="teacher.rating >= 1 ? '#FDCD25' : '#bfbfbf'"
                      >star_rate</v-icon
                    >
                    <v-icon :color="teacher.rating >= 2 ? '#FDCD25' : '#bfbfbf'"
                      >star_rate</v-icon
                    >
                    <v-icon :color="teacher.rating >= 3 ? '#FDCD25' : '#bfbfbf'"
                      >star_rate</v-icon
                    >
                    <v-icon :color="teacher.rating >= 4 ? '#FDCD25' : '#bfbfbf'"
                      >star_rate</v-icon
                    >
                    <v-icon :color="teacher.rating >= 5 ? '#FDCD25' : '#bfbfbf'"
                      >star_rate</v-icon
                    >
                  </div>
                  <div
                    class="rate"
                    style="text-align:center;height: 25px"
                    v-else
                  ></div>
                  <div class="text-center chips">
                    <v-chip
                      class="ma-1 v-chip"
                      color="#13a8b1"
                      v-for="(subject, index) in teacher.subjects"
                      :key="index"
                      >{{ subject }}</v-chip
                    >
                    <!-- <v-chip class="ma-1 v-chip" color="#13a8b1">
                      اللغة العربية
                    </v-chip>
                    <v-chip class="ma-1 v-chip" color="#13a8b1">
                      اللغة العربية
                    </v-chip>
                    <v-chip class="ma-1 v-chip" color="#13a8b1">
                      اللغة العربية
                    </v-chip>-->
                  </div>
                  <div class="details">
                    <p class="price">
                      <v-icon color="#ffc382">calendar_today</v-icon>
                      {{ $t("Hour price start from") }} {{ teacher.hour_price }}
                      {{ $t("currency") }}
                    </p>
                    <p class="subject">
                      <v-icon color="#ffc382">subject</v-icon>
                      {{ teacher.curriculum }}
                    </p>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div class="text-center">
              <v-pagination
                v-model="page"
                color="#ffc382"
                :length="total"
                v-if="total > 1"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="ads">
      <v-row>
        <img src="../assets/images/ad.jpg" alt="ads" />
      </v-row>
    </section>

    <section class="products">
      <v-container>
        <h2 class="section-title">{{ $t("ourOnlineProducts") }}</h2>

        <v-row>
          <v-col cols="12" sm="3" md="3">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small color="yellow"></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <div class="product">
              <img src="../assets/images/book.png" alt />
              <div class="product-info">
                <h5>
                  كتاب النحو والصرف
                  <v-icon small></v-icon>
                </h5>
                <p class="sub-title">الصف الأول ابتدائي</p>
                <p>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                  <v-icon large>star_rate</v-icon>
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- new -->
    <!-- <section class="news">
      <v-container>
        <h2 class="section-title">الاخبار</h2>
        <v-row>
          <v-col cols="12" sm="12">
            <div class="item">
              <img src="../assets/images/ad.jpg" alt="ads" width="100%" />
              <div class="content-news">
                <p class="text-center">
                  لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                  العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                  مطبوعه ...
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section> -->

    <!-- testimonials -->
    <!-- <section class="testimonials">
      <v-container>
        <h2 class="section-title">اراء المستخدمين</h2>
        <v-row>
          <v-col cols="6" sm="4" md="4" class="item">
            <v-card class="mx-auto" max-width="300" outlined elevation="1">
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    src="../assets/images/female.jpg"
                    class="client-image"
                    alt
                  />
                  <p class="text-center client-name">داليا</p>
                  <p class="desc">
                    لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                    العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                    مطبوعه
                  </p>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="4" class="item">
            <v-card class="mx-auto" max-width="300" outlined elevation="1">
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    src="../assets/images/male.jpg"
                    class="client-image"
                    alt
                  />
                  <p class="text-center client-name">داليا</p>
                  <p class="desc">
                    لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                    العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                    مطبوعه
                  </p>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6" sm="4" md="4" class="item">
            <v-card class="mx-auto" max-width="300" outlined elevation="1">
              <v-list-item three-line>
                <v-list-item-content>
                  <img
                    src="../assets/images/female.jpg"
                    class="client-image"
                    alt
                  />
                  <p class="text-center client-name">داليا</p>
                  <p class="desc">
                    لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على
                    العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم
                    مطبوعه
                  </p>
                </v-list-item-content>
              </v-list-item>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section> -->

    <!-- ====================== newsletter ==================== -->
    <section class="newsletters">
      <v-container>
        <h2 class="section-title">{{ $t("subscribeToOurNewsletters") }}</h2>
        <v-row>
          <v-col cols="8" sm="8">
            <v-text-field label="Outlined" single-line outlined></v-text-field>
          </v-col>
          <v-col cols="4" sm="4">
            <v-btn large class="primary-btn">{{ $t("Subscribe") }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- contact form -->

    <!-- <section class="contact">
      <v-container>
        <h2 class="section-title">اشترك فى نشرتنا الاخبارية</h2>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field label="Outlined" solo></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field label="Outlined" solo></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field label="Outlined" solo></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field label="Outlined" solo></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </section> -->
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  data() {
    return {
      page: 1,
      total: 12,
      teachers: [],
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false
    };
  },
  watch: {
    page: {
      handler() {
        this.getTeachers();
      }
    }
  },
  methods: {
    goToLoginPage() {
      this.$router.push({ path: "/login" });
    },
    setDefaultLocale() {
      if (localStorage.locale == undefined) {
        localStorage.locale = "ar";
        window.location.reload();
      }
    },

    getTeachers() {
      this.$http
        .get(this.getApiUrl + "/teachers", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.teachers = response.data.data.data;
            this.page = response.data.data.current_page;
            this.total = response.data.data.last_page;
          }
        });
    }
  },
  mounted() {
    this.setDefaultLocale();
    this.getTeachers();
  }
};
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

/* header */
.header {
  min-height: 40rem;
  background-image: url("../assets/images/background.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;

  .header-content {
    background-color: $home-overlay;
    // opacity: 0.8;
    min-height: 100%;
    position: relative;
    min-height: 40rem;
    .logo {
      position: absolute;
      right: 15%;
      color: #ffffff;
    }
    .first-half {
      position: absolute;
      top: 30%;
      right: 15%;
      margin-left: 2rem;
      .content {
        .title {
          color: #ffffff;
          font-size: 3rem !important;
          margin-bottom: $margin-bottom !important;
        }
        .desc {
          font-size: $p-font-size !important;
          color: #ffffff;
        }
      }
    }
  }
}

/* features section */
.features {
  margin-top: $margin-top;
  .item {
    max-width: 80%;
    margin: 0 auto;
    .title {
      margin-top: 1rem;
      color: $main-color !important;
      font-size: 1.5rem !important;
      font-weight: 700;
      line-height: 2rem;
    }
    .v-icon {
      font-size: 4rem !important;
      color: $second-color;
    }
  }
}

/* teacher section */
.teachers {
  margin-top: $margin-top;
  .teacher-image {
    max-width: 100px;
    max-height: 100px;
    margin: 0 auto !important;
    border-radius: 50%;
  }
  .teacher-name {
    color: $main-color;
    margin-top: 1rem !important;
    font-weight: bold !important;
  }
  .chips {
    .v-chip {
      color: #ffffff !important;
      background-color: rgb(19 168 177 / 50%) !important;
      .v-size--default {
        font-size: 10px;
      }
    }
  }

  .details {
    color: $second-color;
    p {
      margin-bottom: 0 !important;
      font-size: 0.8rem !important;
    }
  }
}

/* ads section */
.ads {
  margin-top: $margin-top;
  img {
    margin: 0 auto;
    width: 80%;
  }
}

/* products */
.products {
  margin-top: $margin-top;
  .product {
    position: relative;
    // max-width: 90% !important;
    img {
      max-width: 100% !important;
      margin: 0 auto;
      width: 100%;
    }
    .product-info {
      background-color: $home-overlay;
      width: 100% !important;
      color: #ffffff;
      // opacity: 0.8;
      text-align: center !important;
      position: absolute;
      bottom: 6px;
      p {
        margin-bottom: 2px;
      }
      .v-icon {
        font-size: larger !important;
      }
    }
  }
}

.news {
  .content-news {
    background-color: $third-color;
    padding: 1.5rem 1.5rem;
    margin-top: -0.5rem;
    p {
      color: #ffffff !important;
    }
  }
}

.testimonials {
  .item {
    .client-image {
      max-width: 50px !important;
      max-height: 50px !important;
      border-radius: 50%;
      margin: 0 auto !important;
      border: 3px solid $third-color;
    }
    .client-name {
      color: $main-color !important;
      font-size: 1rem !important;
      font-weight: bold;
    }
    .desc {
      color: #888888 !important;
      font-size: 0.8rem !important;
    }
  }
}

.newsletters {
  background-color: #f2f3f6;
  padding-top: $margin-top;
  padding-bottom: $margin-bottom;
  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 45px !important;
  }
}

.contact {
  padding-top: $padding-top;
  padding-bottom: $padding-bottom;
  background-color: #383f50 !important;
}

.mobile-show {
  display: none !important;
}
@media screen and (max-width: 600px) {
  .second-half {
    display: none !important;
  }
  .mobile-show {
    display: block !important;
  }
}

.second-btn {
  border-color: #ffffff !important;
  color: #ffffff !important;
}

.sub-title {
  font-size: 12px !important;
}
.v-application .ma-1 {
  margin: 1px !important;
}
.rate-starts,
.price,
.subject,
.product-info {
  .v-icon {
    color: $third-color;
  }
}
.mx-auto.v-card.v-sheet.v-sheet--outlined.theme--light.elevation-1 {
  max-width: 350px !important;
}

@media (max-width: 600px) {
  .accordion-nav {
    font-size: 12px !important;
    font-weight: bold;
    margin-top: 9rem !important;
    li {
      margin-bottom: 1.5rem;
    }
  }
}
</style>
